import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { SelectOption } from 'src/app/models/select-option.model';

export interface CustomTableFilter {
    key: string;
    description: string;
    type: 'STRING' | 'NUMBER' | 'DATE' | 'ENUM' | 'DIGITS' | 'AUTOCOMPLETE';
    availableOptions?: SelectOption[];
    searchFn?: (query: string) => Observable<SelectOption[]>;
}

@Component({
    selector: 'app-table-filter',
    templateUrl: './table-filter.component.html',
    styleUrls: ['./table-filter.component.scss']
})
export class TableFilterComponent implements OnInit {

    @Output()
    values = new EventEmitter<any>();

    filtersValues: CustomTableFilter[];
    @Input()
    set filters(filters: CustomTableFilter[]) {
        Object.keys(this.formGroup.controls).forEach(control => this.formGroup.removeControl(control));
        this.displayControls = {};
        this.autocompleteOptions = {};
        filters.forEach(filter => {
            this.formGroup.addControl(filter.key, new UntypedFormControl('', []));
            if (filter.type === 'AUTOCOMPLETE') {
                this.displayControls[filter.key] = new UntypedFormControl('');
                this.autocompleteOptions[filter.key] = [];
            }
        });
        this.filtersValues = filters;
    }
    get filters() {
        return this.filtersValues;
    }

    openFilters = false;

    formGroup = new UntypedFormGroup({});
    displayControls: Record<string, UntypedFormControl> = {};
    autocompleteOptions: Record<string, SelectOption[]> = {};

    constructor() { }

    ngOnInit(): void {
    }

    onKeyPressDigits(event: KeyboardEvent): boolean {
        return /[0-9-]/.test(event.key);
    }

    onPasteDigits(event: ClipboardEvent, controlKey: string): void {
        event.preventDefault();
        const pasted = event.clipboardData?.getData('text') ?? '';
        const sanitized = pasted.replace(/[^0-9-]/g, '');
        const control = this.formGroup.get(controlKey);
        if (!control) return;
        const input = event.target as HTMLInputElement;
        const start = input.selectionStart ?? 0;
        const end = input.selectionEnd ?? 0;
        const current = (control.value as string) ?? '';
        control.setValue(current.slice(0, start) + sanitized + current.slice(end));
    }

    onAutocompleteFocus(filter: CustomTableFilter): void {
        if (this.autocompleteOptions[filter.key]?.length > 0) return;
        filter.searchFn?.('').subscribe(options => {
            this.autocompleteOptions[filter.key] = options;
        });
    }

    onAutocompleteInput(filter: CustomTableFilter, value: string): void {
        this.formGroup.get(filter.key)?.setValue(null);
        if (!value) {
            this.autocompleteOptions[filter.key] = [];
            return;
        }
        filter.searchFn?.(value).subscribe(options => {
            this.autocompleteOptions[filter.key] = options;
        });
    }

    onAutocompleteSelect(filterKey: string, option: SelectOption): void {
        this.formGroup.get(filterKey)?.setValue(option.codigo);
    }

    displayAutocomplete(option: SelectOption): string {
        return option?.descripcion ?? '';
    }

    submit() {
        const values = {};
        Object.entries(this.formGroup.value).forEach(([key, value]) => {
            if (value) {
                const filter = this.filtersValues.find(f => f.key === key);
                values[key] = filter?.type === 'DIGITS'
                    ? (value as string).replace(/-/g, '')
                    : value;
            }
        });
        this.values.emit(values);
    }

    clearFilters() {
        Object.keys(this.formGroup.controls).forEach(control => this.formGroup.get(control).setValue(''));
        Object.keys(this.displayControls).forEach(key => {
            this.displayControls[key].setValue('');
            this.autocompleteOptions[key] = [];
        });
        this.values.emit({});
    }

}
